import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const Feature = ({ data }) => (
  <div className="col-15 col-lg-5 mb-30">
    <a
      className="features__feature features__feature--hover features__feature--height-100 features__feature--shadow features__feature--p-20 features__feature--v-align-start"
    >
      {
        data.svgIcon
          ? (
            <>
              <svg className="features__feature__image-hover mw-80">
                <use xlinkHref={data.svgIcon} />
              </svg>

              <h3 className="features__feature__title mb-5">
                {data.title}
                <div className="fs-12 fw-500">{data.subtitle}</div>
              </h3>

              <ul className="im-list">
                {_.map(data.descriptions, (description) => (
                  <li className="d-flex align-items-center">
                    <i className="fa-solid fa-check mr-2" />
                    <div className="fs-12 fw-400 text-left">{description}</div>
                  </li>
                ))}
              </ul>
            </>
          )
          : (
            <>
              <i className={`${data.icon} features__feature__icon`} />
              <h3 className="features__feature__title">{data.title}</h3>
              <p className="features__feature__description">{data.description}</p>
            </>
          )
      }
    </a>
  </div>
);

Feature.propTypes = {
  data: PropTypes.object,
};

export default Feature;
